<template>
  <div class="max-pos-board workflow-wrap" data-max-host>
    <div class="workflow-row max-pos-board__row">
      <div v-for="(column, index) in node.columns" :key="index" class="workflow-column max-pos-board__column">
        <h4>{{ column.title }}</h4>
        <div
          class="list-group"
          @dragover.prevent
          @drop.prevent="drop(index)"
        >
          <div
            v-for="row in column.resolvedRows"
            :key="row.key"
            class="list-group-item workflow-item-wrap max-pos-board__card"
            draggable="true"
            @dragstart="dragStart(index, row)"
            @click="open(row)"
          >
            <strong>{{ row.row.name || ('#' + row.row.id) }}</strong>
            <div v-if="row.row.total != null" class="text-muted">{{ row.row.total }}</div>
            <div class="max-pos-board__moves">
              <template v-for="(dest, destIndex) in node.columns" :key="destIndex">
                <button
                  v-if="destIndex !== index"
                  type="button"
                  class="btn btn-default btn-xs"
                  :disabled="iface.busy.value"
                  v-on:click.stop="move(index, destIndex, row)"
                >{{ dest.title }}</button>
              </template>
            </div>
          </div>
          <div v-if="!(column.resolvedRows && column.resolvedRows.length)" class="text-muted">{{ node.empty || _('Nothing to show.') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useMaxInterface } from '#max-runtime/context.ts'

export default {
  props: ['node'],
  setup () {
    const { $translate } = useNuxtApp()
    return { iface: useMaxInterface(), _: $translate }
  },
  data () {
    return { dragging: null }
  },
  methods: {
    open (row) {
      const open = this.node.open
      if (!open) return
      this.iface.run([{ do: 'navigate', to: open.to, id: open.id || { var: 'row.id' } }], { ...(this.node.scope || {}), row: row.row })
    },
    dragStart (index, row) {
      this.dragging = { index, row }
    },
    drop (index) {
      if (!this.dragging || this.dragging.index === index) return
      this.move(this.dragging.index, index, this.dragging.row)
      this.dragging = null
    },
    move (fromIndex, toIndex, row) {
      const from = this.node.columns[fromIndex]
      const to = this.node.columns[toIndex]
      if (!from || !to || !this.node.on || !this.node.on.move) return
      const add = to.tag_id ? [to.tag_id] : []
      const remove = from.tag_id ? [from.tag_id] : []
      const processed = to.status === 'processed' ? true : to.status === 'notprocessed' ? false : null
      this.iface.run(this.node.on.move, {
        ...(this.node.scope || {}),
        event: {
          id: row.row.id,
          add_tags: add,
          remove_tags: remove,
          processed
        }
      })
    }
  }
}
</script>

<style scoped>
.max-pos-board__row {
  display: flex;
  gap: 12px;
  overflow-x: auto;
}
.max-pos-board__column {
  min-width: 220px;
  flex: 1;
}
.max-pos-board__card {
  cursor: pointer;
}
.max-pos-board__moves {
  margin-top: 6px;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}
</style>
